import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'src/app/models/message';
import { Subsection } from 'src/app/models/obs/subsection';
import { AccessService } from 'src/app/services/access.service';
import { SectionService } from 'src/app/services/obs/section.service';
import { SubsectionService } from 'src/app/services/obs/subsection.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';


@Component({
  selector: 'app-admsubsection-list',
  templateUrl: './admsubsection-list.component.html',
  styleUrl: './admsubsection-list.component.scss'
})
export class AdmsubsectionListComponent implements OnInit {

  idT3: number = null;
  subsection: Subsection = null;
  msg: Message;
  idsectionSelected: string = null;
  isSectionBlocked: boolean = false;

  constructor(
    private subS: SubsectionService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService,
    private tier3Service: Tier3Service,
    private sectionService: SectionService,
    private router: Router,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idsectionSelected = params['idsection'];
    this.getSub4SecAdm(params['idsection']);
    this.getPermission();
    this.getIsBlockedSection(Number(this.idsectionSelected));
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  idTier1 = {}
  idSection = {}

  getPermission() {
    this.idSection['id'] = this.activedRoute.snapshot.params['idsection'] * 1;
    const data0 = this.idSection;
    //Conseguimos el Idtier3 apartir del Idsection
    this.sectionService.getIdTier3(data0).subscribe({
      next: res => {
        //conseguimos el nombre del modulo(idtier1) a partir del idtier3
        this.idTier1['id'] = res['data'].idtier3 * 1

        this.tier3Service.getIdTier1(this.idTier1).subscribe({
          next: res => {

            if (res['data'].idtier1 == 1 || res['data'].idtier1 == 5 || res['data'].idtier1 == 11 || res['data'].idtier1 == 12 || res['data'].idtier1 == 13 || res['data'].idtier1 == 15 || res['data'].idtier1 == 16) {
              this.inf['accessId'] = 1; //tendencia
            }
            if (res['data'].idtier1 == 2 || res['data'].idtier1 == 6 || res['data'].idtier1 == 22) {
              this.inf['accessId'] = 2;//riesgo
            }
            if (res['data'].idtier1 == 3 || res['data'].idtier1 == 4 || res['data'].idtier1 == 23) {
              this.inf['accessId'] = 3;//Oportunidad
            }
            if (res['data'].idtier1 == 7 || res['data'].idtier1 == 17) {
              this.inf['accessId'] = 4;//megatendencia
            }
            if (res['data'].idtier1 == 9 || res['data'].idtier1 == 14 || res['data'].idtier1 == 19) {
              this.inf['accessId'] = 5;//esceneario
            }
            if (res['data'].idtier1 == 8 || res['data'].idtier1 == 16 || res['data'].idtier1 == 17 || res['data'].idtier1 == 18 || res['data'].idtier1 == 19 || res['data'].idtier1 == 24) {
              this.inf['accessId'] = 6;//eventos futuros
            }
            if (res['data'].idtier1 == 20) {
              this.inf['accessId'] = 9;//fuerza
            }
            if (res['data'].idtier1 == 21) {
              this.inf['accessId'] = 10;//tecnologia  
            }


            this.inf['userId'] = this.ts.getUser().id;
            const data = this.inf;

            this.accesService.getPermissionUser(data).subscribe({
              next: res => {
                this.accessMP = res['result'].createSubsection;
                this.accessME = res['result'].editSubsection;
                this.accessMD = res['result'].deleteSubsection;
              },
              error: err => {
                this.msg = err;
              }
            });
          },
          error: err => {
            this.msg = err;
          }
        })
      },
      error: err => {
        this.msg = err;
      }

    });
  }

  getSub4SecAdm(id: string) {
    this.subS.get4secAdm(id).subscribe({
      next: res => { this.subsection = res['data']; },
      error: err => { this.msg = err; }
    });
  }

  remove(id: string, elemento: string) {
    if (confirm('¿Está seguro que desea eliminar de forma permanente el elemento ' + elemento + '?')) {
      this.subS.delete(id).subscribe({
        next: res => {
          this.getSub4SecAdm(this.idsectionSelected);
        },
        error: err => console.error(err)
      });
    }
  }

  getIsBlockedSection(id: number) {
    this.tier3Service.idSectionblocked(id).subscribe({
      next: res => {
        this.isSectionBlocked = res['isBlocked'];;
        this.idT3 = res['idTier3'];
      },
      error: err => { console.log(err); }
    })
  }

  goBack() {
    this.router.navigate(['/adm/seccion/list', this.idT3]);
  }

}
